package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class ScheduleOptRepository(private val httpClient: HttpClient) {
    suspend fun getSuggestions(workplaceId: Long, weekStart: String): Result<List<ScheduleSuggestionDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/schedule/suggestions") {
            parameter("weekStart", weekStart)
        }.body()
    }
    suspend fun applySuggestion(workplaceId: Long, req: ApplySuggestionRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/schedule/apply") { setBody(req) }
    }
}
